<template>
    <b-container fluid class="h-100 p-3 bg-gray-light d-flex flex-column no-gutters" >
        <b-row class="mr-1" align-v="center">
            <b-col>
                <!-- Liste des filtres en multi-nodes -->
                <Pins :FilterTreeStore="filterTreeStore" :Grouping="true" :Variant="Variant" :KeepAncestors.sync="keepAncestors" :PropertiesFilterPinTypes="propertiesFilterPinTypes" />
            </b-col>
            <b-col cols="auto">
                <b-button pill :variant="'outline-' + Variant" @click="deselectAll()">{{ $t('DeselectAll') }}</b-button>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <portal to="NavbarPortal" >
                    <!-- ⚠️ Ajout ici du generateVariantStyle() du fait que le portal est un élément déporté, la génération des --Variant n'est pas faite -->
                    <b-form-checkbox switch v-model="keepAncestors" class="ml-2" :style="generateVariantStyle(Variant)" >
                        {{ $t('KeepAncestors') }}

                    <b-iconstack class="ml-2" font-scale="1.4">
                        <b-icon stacked icon="bar-chart-steps"></b-icon>
                        <b-icon stacked icon="eye-fill" scale="0.45" shift-v="6" shift-h="8" ></b-icon>
                    </b-iconstack>

                    </b-form-checkbox>
                </portal>
            </b-col>
        </b-row>

        <b-row class="pl-4 vh-100 overflow-hidden">
            <b-col class="d-flex flex-column h-100 overflow-hidden">
                <!-- Explication fonction -->
                <b-row>
                    <b-col>
                        <b-row class="align-items-center">
                            <h5 class="mb-0">{{ $t('ManageGrouping') }}</h5>
                        </b-row>
                        <b-row class="mb-0 small">
                            <p>{{ $t('GroupingInfo') }}</p>
                        </b-row>
                    </b-col>
                </b-row>

                <b-row class="pb-3">
                    <!-- Recherche de regroupement -->
                    <b-col cols="6" class="pl-0">
                        <b-input-group>
                            <template #append>
                                <b-button :variant="Variant">
                                    <b-icon font-scale="1.3" :class="`text-${Variant}-light`" icon="search"/>
                                </b-button>
                            </template>
                            <b-form-input :placeholder="$t('Search')" v-model="searchValue"/>
                        </b-input-group>
                    </b-col>
                </b-row>

                <!-- Affichage des regroupements en mode carte -->
                <b-row class="w-100 align-items-stretch pl-0 flex-grow-1 overflow-hidden">
                    <b-container fluid class="h-100 overflow-auto">
                        <!-- 4 pour toutes les tailles d'écran ?? même en 4k/8k ? ==> A voir avec SLAVINA -->
                        <b-row v-if="groupings.length > 0" cols="4">
                            <b-col v-for="grouping in filteredGrouping()" :key="grouping.Id" class="pl-0 pr-3 pb-3">
                                <b-card no-body :class="['border h-100 w-100 pb-0 shadow-sm', { [`border-${Variant}-dark bg-${Variant}-light`]: filter && Object.keys(filter).length > 0 && grouping.Id === Number(filter.Id) }, { 'border-gray-light bg-white': !(filter && Object.keys(filter).length > 0 && grouping.Id === Number(filter.Id)) }]"
                                :footer-class="['pt-0', { [`border-${Variant}-dark bg-${Variant}-light`]: filter && Object.keys(filter).length > 0 && grouping.Id === Number(filter.Id) }, {'bg-white' : !(filter && Object.keys(filter).length > 0 && grouping.Id === Number(filter.Id)) }]"
                                @mouseenter="hoveredCard = grouping.Id" @mouseleave="hoveredCard = null" @click="selectGrouping(grouping)" role="button">
                                    <b-card-body >
                                        <b-row align-v="start" class="pr-2 pb-3">
                                            <!-- Nom + Remarque du regroupement -->
                                            <b-col>
                                                <h5>{{ grouping.Label }}</h5>
                                                <b-card-text class="mb-0 small">
                                                    {{ grouping.Extras.Remark }}
                                                </b-card-text>
                                            </b-col>
                                            <!-- Case de sélection du regroupement -->
                                            <b-col cols="auto" class="d-flex align-items-center">
                                                <b-icon v-if="filter && grouping.Id == Number(filter.Id)" icon="check-circle-fill" :variant="Variant"  />
                                            </b-col>
                                        </b-row>
                                    </b-card-body>
                                    <template #footer>
                                        <!-- Gestion des boutons -->
                                        <!-- masqué au départ => afficher si sélectionné ou survolé -->
                                        <b-row  align-h="between">
                                            <b-col cols="auto" :class="{'invisible' : !(hoveredCard == grouping.Id || grouping.Id == Number(filter?.Id))}">
                                                <b-button pill size="sm" :variant="'outline-' + Variant" class="mr-2">{{ $t('Reset') }}</b-button>
                                                <b-button pill size="sm" variant="outline-danger" class="mr-2" @click.stop="deleteGrouping(grouping.Id)" >{{ $t('Delete') }}</b-button>
                                            </b-col>
                                            <!-- 🤔 EN ATTENDANT que je vois avec Océane -->
                                            <b-col cols="auto">
                                                <b-iconstack v-if="grouping.Extras.KeepAncestors" font-scale="1.4" v-b-tooltip.hover.noninteractive="$t('ToolTipKeepAncestors')">
                                                    <b-icon stacked icon="bar-chart-steps"></b-icon>
                                                    <b-icon stacked icon="eye-fill" scale="0.45" shift-v="6" shift-h="8" ></b-icon>
                                                </b-iconstack>
                                            </b-col>
                                        </b-row>
                                    </template>
                                </b-card>
                            </b-col>
                        </b-row>
                        <b-row v-else class="p-5">
                            <h6>{{ $t('NoData.Line1') }}<i class="bi bi-floppy" /> {{ $t('NoData.Line2') }} <b-icon icon="tags" /></h6>
                        </b-row>
                    </b-container>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script lang="ts">
    import { Component, InjectReactive, ProvideReactive } from 'vue-property-decorator';
    import Pins from "@/components/commons/Pins.vue";
    import { MAIN_FILTER_TREE } from '@/App.settings';
    import SelectModeEnum from '@/enums/SelectModeEnum';
    import ListItem from '@/types/fields/ListItem';
    import FilterT from '@/types/FilterTree/FilterT';
    import locales from './locales/Grouping.json';
    import { ThemeUtils } from '@/components/commons/Utils';
    import PinTypeEnum from '@/enums/PinTypeEnum';

    /** Gestion regroupements */
    @Component({
        components: {
            Pins
        },
        i18n: {
            messages : locales
        }
    })
    export default class Grouping extends ThemeUtils {
        /** Variant de couleur à appliquer sur le composant */
        @InjectReactive()
        public Variant!: string;

        /**  Informe les composants enfants le nom de l'instance d'arborescence à utiliser */
        @ProvideReactive()
        private filterTreeStore = MAIN_FILTER_TREE;

        /** Mode de sélection de l'arborescence avant ouverture des regroupements */
        private previousMode: SelectModeEnum = SelectModeEnum.MultiAdvanced;

        /** Indication de l'identifiant du regroupement pour le survol d'éléments */
        private hoveredCard: number = null;

        /** Valeur de recherche de regroupements */
        private searchValue: string = "";

        /** Indication du regroupement sélectionné (en mode mono-sélection) */
        private filter: FilterT = {} as FilterT;

        /** Liste des regroupements */
        private groupings: ListItem[] = [];

        /** Liste des types de Pin pour les filtres par propriétés */
        private propertiesFilterPinTypes: PinTypeEnum[] = [ PinTypeEnum.None, PinTypeEnum.Tree];

        private keepAncestors: boolean = false;

        /** Permet la sélection d'un regroupement */
        private selectGrouping(grouping : ListItem) {
            if(this.filter && Number(this.filter.Id) == grouping.Id){
                this.$store.dispatch(this.filterTreeStore + "/ClearFilter");
            } else {
                let filter: FilterT = { Id: grouping.Id.toString(), Name: grouping.Label, Remark: "", Color: "", Pins: [] } as FilterT;
                this.$store.dispatch(this.filterTreeStore + "/LoadFilter", { filter: filter });

                this.keepAncestors = grouping.Extras.KeepAncestors;
            }
        }

        /** Permet de retourner la liste des regroupements en prenant en compte la valeur de recherche si renseignés */
        private filteredGrouping() {
            console.debug("Grouping - FilteredGrouping - searchValue.length : %O", this.searchValue.length)
            return this.searchValue.length > 0 ? this.groupings.filter(f => f.Label.toLowerCase().includes(this.searchValue.toLowerCase())) : this.groupings;
        }

        /**
         * Supprime le regroupement sélectionné
         * @param selected Regroupement à supprimer
         */
        private async deleteGrouping(selected: number){
            // 'Modal.Delete.Message' -> "Etes-vous sûr de vouloir supprimer définitivement ce regroupement ?"
            // 'GroupingSuppression' -> "Suppression regroupement"
            await this.$bvModal.msgBoxConfirm(this.$t('Modal.Delete.Message').toString(), {
                title: this.$t('GroupingSuppression').toString(), okVariant: 'danger', okTitle: this.$t('Yes').toString(), cancelTitle: this.$t('No').toString(), hideHeaderClose: true, centered: true, modalClass: 'text-center'
            }).then(value => {
                if(value){
                   // DeleteInProgress ->  "Suppression en cours..."
                    this.$store.dispatch("ShowLoadingMask", this.$t(' DeleteInProgress').toString());

                    this.$store.dispatch(this.filterTreeStore + "/Delete", selected).then( async () => {
                        // Rechargement de tous les filtres post-suppression
                        await this.$store.dispatch(this.filterTreeStore + "/LoadFilters");
                        // Modal.Delete.Success -> "Le regroupement sélectionné a été supprimé avec succès."
                        // 'GroupingSuppression' -> "Suppression regroupement"
						this.$bvToast.toast(this.$t('Modal.Delete.Success').toString(), {
							title: this.$t('GroupingSuppression').toString(),
							autoHideDelay: 3000,
							variant: "success",
							solid: true,
							appendToast: true,
							toaster: "b-toaster-top-center"
						});
					})
					.catch(err => {
						console.error(err);
                        // AnErrorOccured -> Une erreur s'est produite.
                        // 'GroupingSuppression' -> "Suppression regroupement"
						this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {
							title: this.$t('GroupingSuppression').toString(),
							autoHideDelay: 10000,
							variant: "danger",
							solid: true,
							appendToast: true,
							toaster: "b-toaster-top-center"
						});
					})
					.finally(() => {
						this.$store.dispatch("HideLoadingMask", {});
					});
                }
            });
        }

        /** Déselection de tout éléments (regroupement et pins)*/
        private deselectAll() {
            // Suppression des pins
            this.$store.dispatch(this.filterTreeStore + "/RemoveFilter");

            this.keepAncestors = false;
        }

        private unwatchGroupings = undefined;
        private unwatchFilter = undefined;

        /** @todo Colonne Nom, Remarque, bouton supprimer, bouton sélectionner
         * En bas la pagination
         * Si appliquer est vide alors pas de sélection
         */
        async created() {
            this.previousMode = this.$store.getters[this.filterTreeStore + "/GetSelectMode"];
            let grouping: FilterT = this.$store.getters[this.filterTreeStore + "/GetGrouping"];

            if(grouping && Object.keys(grouping).length > 0){
                await this.$store.dispatch(this.filterTreeStore + "/RemoveGrouping");
                await this.$store.dispatch(this.filterTreeStore + "/LoadData", { selectMode: SelectModeEnum.MultiAdvanced, enableGroup: false }).then(() => {
                    this.$store.dispatch(this.filterTreeStore + "/UpdateFilter", grouping);

                    this.keepAncestors = grouping.KeepAncestors;
                })
                .catch(err => {
                    console.error(err);
                    // TreeError.Message ->  Une erreur s'est produite sur le chargement de l'arborescence d'objets
                    this.$bvToast.toast(this.$t('TreeError.Message').toString(), {
                        title: this.$t('Error').toString(),
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                });
            } else {
                 await this.$store.dispatch(this.filterTreeStore + "/LoadData", { selectMode: SelectModeEnum.MultiAdvanced, enableGroup: false })
                 .catch(err => {
                    console.error(err);
                    // TreeError.Message ->  Une erreur s'est produite sur le chargement de l'arborescence d'objets
                    this.$bvToast.toast(this.$t('TreeError.Message').toString(), {
                        title: this.$t('Error').toString(),
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                });
            }

            // Chargement des regroupements au démarrage
            this.unwatchGroupings = this.$store.watch((state, getters) => getters[this.filterTreeStore + '/GetFilters'](), val => {
				this.groupings = val;
			}, { immediate: true });

            // Chargement des regroupements au démarrage
            this.unwatchFilter = this.$store.watch((state, getters) => getters[this.filterTreeStore + '/GetFilter'], val => {
				this.filter = val;
			}, { immediate: true });

            /** Chargement des listes : Type d'objet */
            await this.$store.dispatch("LoadListItems", [{ listName: 'ObjectType' }]);
        }

        async beforeDestroy() {
            if(this.unwatchGroupings)
                this.unwatchGroupings();
            if(this.unwatchFilter)
                this.unwatchFilter();

            await this.$store.dispatch(this.filterTreeStore + "/SetKeepAncestors", this.keepAncestors);
            await this.$store.dispatch(this.filterTreeStore + "/ForceGrouping");
            await this.$store.dispatch(this.filterTreeStore + "/LoadData", { selectMode: this.previousMode, enableGroup: true })
            .catch(err => {
                console.error(err);
                // TreeError.Message ->  Une erreur s'est produite sur le chargement de l'arborescence d'objets
                this.$bvToast.toast(this.$t('TreeError.Message').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
        }
    }
</script>

<style scoped>
	/** Pour que la page active prenne en compte la couleur de Variant */
	:deep(.page-item.active .page-link) {
		background-color: var(--Variant) !important;
	}

	:deep(.page-link:hover) {
		background-color: var(--VariantLight) !important;
	}

    /** Variable --Variant injectée via generateVariantStyle(Variant) dans ObjectDisplaying (composant commun à toute la fiche objet) */
    :deep(input[type=checkbox]:checked) {
        /** Change la couleur de la checkbox */
        accent-color: var(--Variant) !important;
    }

    :deep(input[type=radio]:checked) {
        /** Change la couleur du bouton radio */
        accent-color: var(--Variant) !important;
    }

    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est coché */
    :deep(.custom-control-input:checked ~ .custom-control-label::before) {
            border-color: var(--Variant) !important;
            background-color: var(--Variant) !important;
        }

    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est actif */
    :deep(.custom-control-input:active ~ .custom-control-label::before) {
        background-color: var(--Variant) !important;
        border-color: var(--Variant) !important;
    }
</style>